import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchHomeData } from "./homeAPI";
export interface CodeOfConductState {
  codeOfConductData: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: CodeOfConductState = {
  codeOfConductData: {},
  status: "idle",
};

export const GetCodeOfConductData = createAsyncThunk("user/fetchHomeData", async (id:any) => {
  const response = await fetchHomeData(id);
  return response;
});

export const codeOfConductSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCodeOfConductData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCodeOfConductData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetCodeOfConductData.fulfilled, (state, action) => {
        state.status = "success";
        state.codeOfConductData = action.payload.codeOfConduct;
      });
  },
});

export const {} = codeOfConductSlice.actions;

export const selectcodeOfConductData = (state: RootState) => {
  return state.codeOfConduct.codeOfConductData;
};

export default codeOfConductSlice.reducer;
